/** Lowercase the trailing "s" in "LLMs" within the title of post 61718 */
export const llmsLowercase = () => {
  const post = document.getElementById('post-61718');
  if (!post) return;

  const h1 = post.querySelector('h1');
  if (!h1 || h1.querySelector('.lowercase-letter')) return; // avoid double-wrapping

  h1.innerHTML = h1.innerHTML.replace(/LLMs/g, 'LLM<span class="lowercase-letter">s</span>');
};
